import Image from 'next/image'
import React from 'react'

type InstructorCardTypes = {
  profile_image_url: string
  description: string
  name: string
  designation: string
  type: string
  previous_designation: string
}
const InstructorCard = (props: InstructorCardTypes) => {
  const {
    name,
    previous_designation,
    designation,
    profile_image_url,
    type,
    description
  } = props

  return (
    <div className="bg-white w-full sm:max-w-[490px] rounded-lg overflow-hidden">
      <div
        style={{
          background: 'linear-gradient(0deg, #ffc0cb00 50%, #5A5AB4 50%)'
        }}>
        <div className="flex flex-row gap-3 p-7 items-center">
          <div className="p-1 bg-white rounded-full h-min">
            <div className="rounded-full overflow-hidden">
              <Image
                src={profile_image_url}
                alt={''}
                width={150}
                height={150}
                className="w-24 h-24 sm:w-36 sm:h-36"
              />
            </div>
          </div>
          <div className="flex flex-col py-3 gap-4">
            <div className="text-white h-1/2">
              <h2 className="text-2xl font-bold">{name}</h2>
              <p>{designation}</p>
            </div>
            <div className="text-primary-dark h-1/2">
              <h3 className="text-lg font-bold">{type}</h3>
              {previous_designation && <p>{previous_designation}</p>}
            </div>
          </div>
        </div>
      </div>
      <div>
        <p className="text-gray-700 p-7 pt-0">{description}</p>
      </div>
    </div>
  )
}

export default InstructorCard
